import React, { useCallback, useState } from "react";

import I24Chevron2 from "assets/icons/I24Chevron2";

import styleConst from "constants/style";

import { Container, Header, IconContainer, Title, Content } from "./styles";

type Props = {
  title: string;
  children: React.ReactNode;
  isVisible?: boolean;
  withToggle?: boolean;
  className?: any;
};

const Accordion: React.FC<Props> = ({
  className,
  children,
  title,
  isVisible: isVisibleProp,
  withToggle: withToggleProp,
}) => {
  const [isVisible, setIsVisible] = useState(isVisibleProp ?? true);
  const withToggle = withToggleProp ?? true;

  const toggle = useCallback(() => {
    if (withToggle) {
      setIsVisible((prev) => !prev);
    }
  }, [withToggle]);

  return (
    <Container className={className}>
      <Header onClick={toggle}>
        <Title>{title}</Title>
        {withToggle ? (
          <IconContainer isOpened={isVisible}>
            <I24Chevron2 color={styleConst.colors.black} />
          </IconContainer>
        ) : null}
      </Header>

      {isVisible ? <Content>{children}</Content> : null}
    </Container>
  );
};

export default Accordion;
